import { Base } from './_base.model';

export class DownloadForm extends Base {
  id: number;
  event_card_category_id: string;
  form: string;
  filename: string;
  topics: any[];
  bureaus: any[];
  products: any[];
  meeting_types: any[];
  agencies: any[];
  form_file: string | ArrayBuffer;
  category: string;
}
